import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import { Checkbox } from "react-md";
import PNXLabel from "./PNXLabel";

interface ReadOnlyProps {
  controlProps: controls.SelectGroupItem;
}

interface Props extends ReadOnlyProps {
  updateValue: (newValue: string) => void;
  parentOnBlur: () => void;
};

const PhoenixSelectGroupItem = ({
  controlProps,
  updateValue,
  parentOnBlur,
} : Props) => {

  const id = `selectgroupitem-${controlProps.id}`;

  return <div>
    <Checkbox
      id={id}
      name={id}
      label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
      value={controlProps.optionValue}
      onChange={(checked) => updateValue(checked ? controlProps.optionValue : "")}
      onBlur={parentOnBlur}
      checked={controlProps.optionValue === controlProps.value}
    />
  </div>;
};

export const PhoenixSelectGroupItemReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {
  //return <PNXLabel>{controlProps.label}</PNXLabel>;

  const id = `readonlyselectgroupitem-${controlProps.id}`;
  
  return <div>
    <Checkbox
      className="readonly-selectgroupitem"
      id={id}
      name={id}
      label={<PNXLabel>{controlProps.label}</PNXLabel>}
      value={controlProps.optionValue}
      disabled
      checked={controlProps.optionValue === controlProps.value}
    />
  </div>;
};

export default PhoenixSelectGroupItem;